import Gigya from './gigya.js'
import { BaseParamsSite } from './interfaces/base-params.js'

export * from './interfaces/gigya-response.js'
export * from './interfaces/base-params.js'

export class Audit {
	constructor(protected gigya: Gigya) {}

	/**
	 * The method enables you to search your site's audit log using an SQL-like query.
	 *
	 * @see http://developers.gigya.com/display/GD/audit.search
	 */
	public search(params: BaseParamsSite & AuditSearchParams) {
		return this.gigya.request<AuditSearchResponse>('audit.search', params)
	}
}

export interface AuditSearchParams {
	query: string
}

export interface AuditSearchResponse {
	objectsCount: number
	totalCount: number
	results: Array<{
		'@timestamp': string
		callID: string
		errCode: string
		endpoint: string
		errMessage: string
		authType?: string
		userKey: string
		sourceIP: string
		params: Record<string, unknown>
		uid: string
		apikey: string
		httpReq: {
			SDK: string
			country: string
		}
		userKeyDetails?: {
			description: string
			name: string
			emailDomain: string
		}
	}>
}

export default Audit
